import React from 'react'

import {
  FloorAndTotalFloorWrapperType,
  RealEstateFeatures,
  RealEstateSiteRecommendedUseTypes,
} from '../../../../../../@types/types'
import { OtherFacilitiesWrapperProps } from '../OtherFacilities'
import EstateFeatures from '../../commonFields/estateFeatures/EstateFeatures'
import InteriorQuality from '../fields/interiorQuality/InteriorQuality'
import InteriorQualityDropdown from '../fields/interiorQuality/InteriorQualityDropdown'
import PetsAllowed from '../fields/petsAllowed/PetsAllowed'
import WebViewParkingSpace from '../fields/webViewParkingSpace/WebViewParkingSpace'
import BathroomField from '../../commonFields/bathroom/BathroomField'
import FloorAndTotalFloor from '../fields/floorAndTotalFloor/FloorAndTotalFloor'
import ParkingSpace from '../fields/parkingSpace/ParkingSpace'
import { getRealEstateFeatures } from '../../../../../../services/domain/estateFeatures'
import FlooringType from '../fields/flooringType/FlooringType'
import PowerSupplyField from '../fields/powerSupply/PowerSupplyField'
import FloorLoadField from '../fields/floorLoad/FloorLoadField'
import Crane from '../fields/crane/Crane'
import LanCablesField from '../fields/lanCables/LanCablesField'
import AirConditioningField from '../fields/airConditioning/AirConditioningField'
import TotalFloorsField from '../fields/totalFloorsField/TotalFloorsField'
import LengthGarageField from '../fields/lengthGarageField/LengthGarageField'
import UsableAreaField, { UsableAreaVariants } from '../fields/usableAreaField/UsableAreaField'
import WidthGarageField from '../fields/widthGarageField/WidthGarageField'
import HeightGarageField from '../fields/heightGarageField/HeightGarageField'
import { AdTitle, AdTitleValidationResult } from '../../commonFields/adTitle/AdTitle'
import IntermediateRent from '../fields/intermediateRent/IntermediateRent'
import MoveInDate from '../../commonFields/moveInDate/MoveInDate'
import FreeUntilDate from '../../commonFields/freeUntilDate/FreeUntilDate'
import MinimumTermOfLease from '../fields/minimumTermOfLease/MinimumTermOfLease'
import GrzField from '../fields/grzField/GrzField'
import RentSubsidy from '../fields/rentSubsidy/RentSubsidy'
import GfzField from '../fields/gfzField/GfzField'
import MinRentalTime from '../fields/minRentalTime/MinRentalTime'
import MaxRentalTime from '../fields/maxRentalTime/MaxRentalTime'
import FrontWindowLength from '../fields/frontWindowLength/FrontWindowLength'
import NumberOfSeats from '../fields/numberOfSeats/NumberOfSeats'
import NumberOfBeds from '../fields/numberOfBeds/NumberOfBeds'
import AreaCoverage from '../fields/areaCoverage/AreaCoverage'
import ConstructibleAfter from '../fields/constructibleAfter/ConstructibleAfter'
import LocationClassificationType from '../fields/locationClassificationType/LocationClassificationType'
import SupplyType from '../fields/supplyType/SupplyType'
import UsageType from '../fields/usageType/UsageType'
import ConstructionPhase from '../fields/constructionPhase/ConstructionPhase'
import SiteRecommendedUseTypes from '../fields/siteRecommendedUseTypes/SiteRecommendedUseTypes'
import { getRealEstateSiteRecommendedUseTypes } from '../../../../../../services/domain/siteRecommendedUseTypes'
import RentalIncome from '../fields/rentalIncome/RentalIncome'
import HeatingTypeField from '../../commonFields/heatingType/HeatingTypeField'
import { getDefaultClasses, GetDefaultClassesOptions, Variant } from '../../../../../../utils/style-utils'
import LoadLifting from '../fields/loadLifting/LoadLifting'
import GoodsLift from '../fields/loadLifting/GoodsLift'
import NoBedrooms from '../fields/noBedrooms/NoBedrooms'
import { styleWrapper } from '../../basicInfo/wrappers/basicInfoFieldsWrapper'
import FreeFrom from '../../costs/fields/freeFrom/FreeFrom'
import PriceMultiplier from '../fields/priceMultiplier/PriceMultiplier'
import RentalIncomeFieldFactory from '../fields/rentalIncomeFieldFactory/RentalIncomeFieldFactory'
import IndustrialAreaField from '../fields/industrialArea/IndustrialAreaField'
import PricePerSQM from '../fields/pricePerSqm/PricePerSQM'
import ServiceCharge from '../fields/serviceCharge/ServiceCharge'
import AdditionalAreaField from '../fields/additionalArea/AdditionalAreaField'
import Furnishing from '../../flatShareRoomProperties/fields/furnishing/Furnishing'
import MaxNumberOfPersons from '../fields/maxNumberOfPersons/MaxNumberOfPersons'

//<--! Start Title Fields !-->

export const adTitle = () => (props: OtherFacilitiesWrapperProps) => (
  <AdTitle
    {...{
      ...props,
      validationMessages: props.validationMessages as AdTitleValidationResult,
    }}
  />
)

//<--! Start Title Fields !-->

//<--! Start Estate Features !-->

export const estateFeatures =
  (features: RealEstateFeatures[], customLabel?: React.ReactNode, wrapperClassName?: string) =>
  (props: OtherFacilitiesWrapperProps) => (
    <EstateFeatures
      {...props}
      estateFeatures={getRealEstateFeatures(features)}
      customLabel={customLabel}
      wrapperClassName={wrapperClassName}
    />
  )

//<--! End Estate Features !-->

//<--! Start Detail Fields !-->

export const siteRecommendedUseTypes =
  (recommendedUseTypes: RealEstateSiteRecommendedUseTypes[]) => (props: OtherFacilitiesWrapperProps) => (
    <SiteRecommendedUseTypes
      {...props}
      siteRecommendedUseTypes={getRealEstateSiteRecommendedUseTypes(recommendedUseTypes)}
    />
  )

export const interiorQuality = () => (props: OtherFacilitiesWrapperProps) => <InteriorQuality {...props} />

export const interiorQualityField = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <InteriorQualityDropdown {...props} wrapperClassName={wrapperClassName} />
)

export const petsAllowed =
  (wrapperClassName?: string, showTooltip?: boolean, showPopoverTooltip?: boolean) =>
  (props: OtherFacilitiesWrapperProps) => (
    <PetsAllowed
      {...props}
      wrapperClassName={wrapperClassName}
      showTooltip={showTooltip}
      showPopoverTooltip={showPopoverTooltip}
    />
  )

export const webViewParkingSpace = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <WebViewParkingSpace {...props} wrapperClassName={wrapperClassName} doReset={props.doReset!} />
)

export const airConditioningField =
  (variant: Variant = 'full') =>
  (props: OtherFacilitiesWrapperProps) =>
    styleWrapper(<AirConditioningField {...props} />, variant)

//TODO: bathroomField is shared field with BasicInfo screen. Fields like this one need to be moved to a shared-fields folder
export const bathroomField = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <BathroomField {...props} wrapperClassName={wrapperClassName} />
)

export const floorAndTotalFloor = (variant?: FloorAndTotalFloorWrapperType) => (props: OtherFacilitiesWrapperProps) => {
  let wrapperClassName = 'grid-item'
  let levitatingContentWrapperClassName = ''

  if (variant === 'left') {
    wrapperClassName = 'grid-item one-whole desk-one-half desk-padding-right-m'
    levitatingContentWrapperClassName = 'lap-one-half lap-padding-right-m'
  } else if (variant === 'right') {
    wrapperClassName = 'grid-item one-whole desk-one-half desk-padding-left-m'
    levitatingContentWrapperClassName = 'lap-one-half lap-padding-right-m'
  }

  return (
    <FloorAndTotalFloor
      {...props}
      id='floorAndTotalFloor'
      wrapperClassName={wrapperClassName}
      levitatingContentWrapperClassName={levitatingContentWrapperClassName}
    />
  )
}

export const flooringType = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <FlooringType {...props} wrapperClassName={wrapperClassName} />
)

export const floorLoadField =
  (wrapperClassName?: string, translationLabel?: string) => (props: OtherFacilitiesWrapperProps) => (
    <FloorLoadField {...props} wrapperClassName={wrapperClassName} translationLabel={translationLabel} />
  )

export const powerSupplyField = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <PowerSupplyField {...props} wrapperClassName={wrapperClassName} />
)

export const lanCablesField =
  (variant: Variant = 'full') =>
  (props: OtherFacilitiesWrapperProps) =>
    styleWrapper(<LanCablesField {...props} />, variant)

export const totalFloorsField = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <div className={wrapperClassName}>
    <TotalFloorsField {...props} />
  </div>
)

export const heatingTypeField = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <HeatingTypeField {...props} wrapperClassName={wrapperClassName} />
)

export const lengthGarageField = () => (props: OtherFacilitiesWrapperProps) => <LengthGarageField {...props} />

export const usableAreaField =
  (variant?: UsableAreaVariants, wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
    <UsableAreaField {...props} variant={variant} wrapperClassName={wrapperClassName} />
  )
export const widthGarageField = () => (props: OtherFacilitiesWrapperProps) => <WidthGarageField {...props} />

export const heightGarageField = () => (props: OtherFacilitiesWrapperProps) => <HeightGarageField {...props} />

export const intermediateRent = () => (props: OtherFacilitiesWrapperProps) => <IntermediateRent {...props} />

export const moveInDateAndFreeUntilDate = () => (props: OtherFacilitiesWrapperProps) => (
  <>
    <MoveInDate {...props} wrapperClassName={getDefaultClasses('left')} />
    {(props.insertionData.intermediateRent ?? true) && (
      <FreeUntilDate {...props} wrapperClassName={getDefaultClasses('right')} />
    )}
  </>
)
export const minimumTermOfLease = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <MinimumTermOfLease {...props} wrapperClassName={wrapperClassName} />
)

export const rentSubsidy = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <RentSubsidy {...props} wrapperClassName={wrapperClassName} />
)

export const grzField = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <GrzField {...props} wrapperClassName={wrapperClassName} />
)

export const gfzField = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <GfzField {...props} wrapperClassName={wrapperClassName} />
)

export const minRentalTime = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <MinRentalTime {...props} wrapperClassName={wrapperClassName} />
)

export const maxRentalTime = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <MaxRentalTime {...props} wrapperClassName={wrapperClassName} />
)

export const maxNumberOfPersons = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <MaxNumberOfPersons {...props} wrapperClassName={wrapperClassName} />
)

export const frontWindowLength = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <FrontWindowLength {...props} wrapperClassName={wrapperClassName} />
)

export const numberOfSeats = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <NumberOfSeats {...props} wrapperClassName={wrapperClassName} />
)

export const numberOfBeds = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <NumberOfBeds {...props} wrapperClassName={wrapperClassName} />
)

export const noBedrooms =
  (variant: Variant = 'left') =>
  (props: OtherFacilitiesWrapperProps) =>
    styleWrapper(<NoBedrooms {...props} />, variant)

export const areaCoverage = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <AreaCoverage {...props} wrapperClassName={wrapperClassName} />
)

export const constructibleAfter = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <ConstructibleAfter {...props} wrapperClassName={wrapperClassName} />
)

export const locationClassificationType = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <LocationClassificationType {...props} wrapperClassName={wrapperClassName} />
)

export const supplyType = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <SupplyType {...props} wrapperClassName={wrapperClassName} />
)

export const usageType = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <UsageType {...props} wrapperClassName={wrapperClassName} />
)

export const constructionPhase = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <ConstructionPhase {...props} wrapperClassName={wrapperClassName} />
)

export const rentalIncome = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <RentalIncome {...props} screenId={props.screenId!} wrapperClassName={wrapperClassName} />
)

export const priceMultiplier = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <PriceMultiplier {...props} wrapperClassName={wrapperClassName} />
)

export const rentalIncomeActual =
  (variant: Variant = 'left', options?: GetDefaultClassesOptions) =>
  (props: OtherFacilitiesWrapperProps) =>
    styleWrapper(<RentalIncomeFieldFactory {...props} property={'rentalIncomeActual'} />, variant, options)

export const rentalIncomeTarget =
  (variant: Variant = 'right', options?: GetDefaultClassesOptions) =>
  (props: OtherFacilitiesWrapperProps) =>
    styleWrapper(<RentalIncomeFieldFactory {...props} property={'rentalIncomeTarget'} />, variant, options)

export const industrialAreaField = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <IndustrialAreaField {...props} wrapperClassName={wrapperClassName} />
)

export const additionalAreaField = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <AdditionalAreaField {...props} wrapperClassName={wrapperClassName} />
)

export const pricePerSQM = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <PricePerSQM {...props} wrapperClassName={wrapperClassName} />
)

export const serviceCharge = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <ServiceCharge {...props} wrapperClassName={wrapperClassName} />
)
//TODO: The field Field is shared with BasicInfo screen -> move to sharedFields folder
export const isFurnished = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <Furnishing {...props} wrapperClassName={wrapperClassName} />
)

//<--! End Detail Fields !-->

//<--! Start Details Combined Fields !-->

interface ParkingSpaceType {
  showParkingSpaceType?: boolean
  hasGarageLabel?: boolean
  parkingSpaceRentTypeLabel?: 'Rent' | 'RentPerItem' | 'RentBuyingPrice'
}

export const parkingSpace =
  ({ showParkingSpaceType, hasGarageLabel, parkingSpaceRentTypeLabel }: ParkingSpaceType) =>
  (otherFacilitiesWrapperProps: OtherFacilitiesWrapperProps) => (
    <ParkingSpace
      {...otherFacilitiesWrapperProps}
      screenId={otherFacilitiesWrapperProps.screenId!}
      noParkingSpaces={otherFacilitiesWrapperProps.insertionData.noParkingSpaces?.toString()}
      parkingSpaceRent={otherFacilitiesWrapperProps.insertionData.parkingSpaceRent}
      parkingSpaceType={otherFacilitiesWrapperProps.insertionData.parkingSpaceType}
      showParkingSpaceType={showParkingSpaceType}
      hasGarageLabel={hasGarageLabel}
      parkingSpaceRentTypeLabel={parkingSpaceRentTypeLabel}
      noParkingSpacesValidation={otherFacilitiesWrapperProps.validationMessages!.noParkingSpaces ?? []}
      parkingSpaceRentValidation={otherFacilitiesWrapperProps.validationMessages!.parkingSpaceRent ?? []}
      doReset={otherFacilitiesWrapperProps.doReset!}
      onChange={(property, value) =>
        otherFacilitiesWrapperProps.onChange({ screen: otherFacilitiesWrapperProps.screenName, property }, value)
      }
    />
  )

export const loadLifting = () => (otherFacilitiesWrapperProps: OtherFacilitiesWrapperProps) => (
  <LoadLifting
    {...otherFacilitiesWrapperProps}
    toggleEnabled={otherFacilitiesWrapperProps.insertionData.loadLifting}
    amountValue={otherFacilitiesWrapperProps.insertionData.loadLiftingValue}
    validation={otherFacilitiesWrapperProps.validationMessages!.loadLiftingValue ?? []}
    onChange={(property, value) =>
      otherFacilitiesWrapperProps.onChange({ screen: otherFacilitiesWrapperProps.screenName, property }, value)
    }
  />
)
export const goodsLift = () => (otherFacilitiesWrapperProps: OtherFacilitiesWrapperProps) => (
  <GoodsLift
    {...otherFacilitiesWrapperProps}
    toggleEnabled={otherFacilitiesWrapperProps.insertionData.goodsLift}
    amountValue={otherFacilitiesWrapperProps.insertionData.goodsLiftLoad}
    validation={otherFacilitiesWrapperProps.validationMessages!.goodsLiftLoad ?? []}
    onChange={(property, value) =>
      otherFacilitiesWrapperProps.onChange({ screen: otherFacilitiesWrapperProps.screenName, property }, value)
    }
  />
)

export const crane = () => (otherFacilitiesWrapperProps: OtherFacilitiesWrapperProps) => (
  <Crane
    screenId={otherFacilitiesWrapperProps.screenId!}
    crane={otherFacilitiesWrapperProps.insertionData.crane}
    craneValue={otherFacilitiesWrapperProps.insertionData.craneValue}
    craneValueValidation={otherFacilitiesWrapperProps.validationMessages!.craneValue ?? []}
    doReset={otherFacilitiesWrapperProps.doReset!}
    onChange={(property, value) =>
      otherFacilitiesWrapperProps.onChange({ screen: otherFacilitiesWrapperProps.screenName, property }, value)
    }
  />
)

export const moveInDate = (wrapperClassName?: string) => (otherFacilitiesWrapperProps: OtherFacilitiesWrapperProps) => (
  <MoveInDate wrapperClassName={wrapperClassName} {...otherFacilitiesWrapperProps} />
)

export const freeFrom = (wrapperClassName?: string) => (otherFacilitiesWrapperProps: OtherFacilitiesWrapperProps) => (
  <FreeFrom wrapperClassName={wrapperClassName} {...otherFacilitiesWrapperProps} />
)

//<--! End Details Combined Fields !-->
